document.addEventListener('DOMContentLoaded', function () {
  function disableScroll() {
    document.body.classList.add('no-scroll');
  }

  function enableScroll() {
    document.body.classList.remove('no-scroll');
  }

  // function injectLabelFontSize() {
  //   const chatComponent = document.querySelector('shopify-agent');
  //   if (!chatComponent?.shadowRoot) return false;
  //   if (chatComponent.shadowRoot.querySelector('#custom-label-font-style')) return true;

  //   const style = document.createElement('style');
  //   style.id = 'custom-label-font-style';
  //   style.textContent = `
  //     .activator__label {
  //       font-size: 18px !important;
  //       color: #fff !important;
  //       font-weight: 500 !important;
  //     }
  //   `;
  //   chatComponent.shadowRoot.appendChild(style);
  //   return true;
  // }

  // let attempts = 0;
  // const maxAttempts = 10;
  // const interval = setInterval(() => {
  //   attempts++;
  //   if (injectLabelFontSize() || attempts >= maxAttempts) clearInterval(interval);
  // }, 500);

  // /* --------------------------------------------
  //  * Inbox Chat Open Functionality & Retry Logic
  //  * -------------------------------------------- 
  //    open shopify inbox chat bot use class this open-chat
  //    <a href="#" class="open-chat">chat</a> */
  // const openChatLinks = document.querySelectorAll('.open-chat');

  // openChatLinks.forEach(function (link, index) {
  //   link.addEventListener('click', function (event) {
  //     event.preventDefault();

  //     const tryToOpenChat = () => {
  //       const chatComponent = document.querySelector('shopify-agent');

  //       if (!chatComponent) {
  //         console.warn('[Inbox Chat] <shopify-agent> not found');
  //         return false;
  //       }

  //       if (!chatComponent.shadowRoot) {
  //         console.warn('[Inbox Chat] shadowRoot not available on chat component');
  //         return false;
  //       }

  //       const chatButton = chatComponent.shadowRoot.querySelector('button');

  //       if (!chatButton) {
  //         console.warn('[Inbox Chat] Chat button not found inside shadowRoot');
  //         return false;
  //       }

  //       chatButton.click();
  //       return true;
  //     }

  //       ;

  //     // Retry logic in case it's not ready immediately
  //     let attempts = 0;
  //     const maxAttempts = 10;

  //     const interval = setInterval(() => {
  //       attempts++;

  //       if (tryToOpenChat() || attempts >= maxAttempts) {
  //         clearInterval(interval);

  //         if (attempts >= maxAttempts) {
  //           console.error('[Inbox Chat] Failed to open chat after multiple attempts');
  //         }
  //       }
  //     }

  //       , 500); // Try every 500ms
  //   });
  // });

// (function () {
//   // Shared helper: resolves once <shopify-agent> shadowRoot is ready, with retry
//   function waitForShadowRoot(callback, { maxAttempts = 10, delay = 500 } = {}) {
//     let attempts = 0;
//     const interval = setInterval(() => {
//       attempts++;
//       const chatComponent = document.querySelector('shopify-agent');
//       const ready = chatComponent && chatComponent.shadowRoot;

//       if (ready) {
//         clearInterval(interval);
//         callback(chatComponent.shadowRoot);
//       } else if (attempts >= maxAttempts) {
//         clearInterval(interval);
//         console.warn('[Inbox Chat] shadow root not ready after retries');
//       }
//     }, delay);
//   }

//   // 1. Inject custom label styles once shadow root exists
//   waitForShadowRoot((shadowRoot) => {
//     if (shadowRoot.querySelector('#custom-label-font-style')) return;

//     const style = document.createElement('style');
//     style.id = 'custom-label-font-style';
//     style.textContent = `
//       .activator__label {
//         font-size: 18px !important;
//         color: #fff !important;
//         font-weight: 500 !important;
//       }
//     `;
//     shadowRoot.appendChild(style);
//   });

//   // 2. Open chat via any .open-chat trigger, using event delegation
//   //    so it also works for links added to the DOM later
//   document.addEventListener('click', function (event) {
//     const link = event.target.closest('.open-chat');
//     if (!link) return;

//     event.preventDefault();

//     waitForShadowRoot((shadowRoot) => {
//       const chatButton = shadowRoot.querySelector('button');
//       if (chatButton) {
//         chatButton.click();
//       } else {
//         console.warn('[Inbox Chat] Chat button not found inside shadowRoot');
//       }
//     });
//   });
// })();

(function () {
  // console.log('[Inbox Chat] script loaded'); 

  // Recursively search through arbitrarily nested shadow roots for a selector
  function deepQuerySelector(root, selector) {
    const direct = root.querySelector(selector);
    if (direct) return direct;

    const all = root.querySelectorAll('*');
    for (const el of all) {
      if (el.shadowRoot) {
        const found = deepQuerySelector(el.shadowRoot, selector);
        if (found) return found;
      }
    }
    return null;
  }

  function findHost() {
    return document.querySelector('shopify-chat');
  }

  // 1. Keep the label styled, self-healing on every poll since the widget
  //    re-renders / resets its hydration state on click.
  function applyLabelStyle() {
  const host = findHost();
  if (!host || !host.shadowRoot) return;

  const button = deepQuerySelector(host.shadowRoot, 'button.activator, button[part="activator"]');
  const label = deepQuerySelector(host.shadowRoot, '.activator__label');

  if (!button || !label) {
    // console.warn('[Inbox Chat] button or label not found this pass');
    return;
  }

  if (button.dataset.customStyled === 'true') return; // already done, skip repeat work

  label.style.setProperty('font-size', '18px', 'important');
  label.style.setProperty('color', '#fff', 'important');
  label.style.setProperty('font-weight', '500', 'important');

  button.style.setProperty('background', '#BBCCAD', 'important');

  button.dataset.customStyled = 'true';
  // console.warn('[Inbox Chat] button + label styled', button, label);
}

  setInterval(applyLabelStyle, 200);

  // 2. Open chat via any .open-chat trigger
  document.addEventListener('click', function (event) {
    // console.warn('[Inbox Chat] test warn');
    const link = event.target.closest('.open-chat');
    if (!link) return;

    // console.log('[Inbox Chat] .open-chat trigger clicked');
    event.preventDefault();

    let attempts = 0;
    const maxAttempts = 10;
    const interval = setInterval(() => {
      attempts++;
      const host = findHost();
      const btn = host && host.shadowRoot
        ? deepQuerySelector(host.shadowRoot, 'button.activator, button[part="activator"]')
        : null;

      // console.log(`[Inbox Chat] attempt ${attempts}/${maxAttempts} — host: ${!!host}, button: ${!!btn}`);

      if (btn) {
        clearInterval(interval);
        // console.log('[Inbox Chat] clicking activator button', btn);
        btn.click();
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        // console.warn('[Inbox Chat] activator button not found after retries — is <shopify-chat> in the DOM?');
      }
    }, 300);
  });
})();

// (function () {
//   const SELECTORS = {
//     host: '#ShopifyChat',
//     button: 'button[data-spec="toggle-button"]',
//     label: '.chat-title'
//   };

//   /**
//    * Wait until Shopify Inbox is ready
//    */
//   function waitForInbox(callback) {
//     let retries = 20;

//     const timer = setInterval(() => {
//       const host = document.querySelector(SELECTORS.host);

//       if (host?.shadowRoot) {
//         clearInterval(timer);
//         callback(host);
//         return;
//       }

//       if (--retries <= 0) {
//         clearInterval(timer);
//         console.warn('[Inbox Chat] Widget not found.');
//       }
//     }, 300);
//   }

//   /**
//    * Inject styles once
//    */
//   function injectStyles(host) {
//     const shadow = host.shadowRoot;

//     if (shadow.querySelector('#custom-inbox-style')) return;

//     const style = document.createElement('style');
//     style.id = 'custom-inbox-style';

//     style.textContent = `
//       .chat-title{
//         font-size:18px !important;
//         font-weight:500 !important;
//         color:#fff !important;
//       }

//       .chat-toggle{
//         background:#BBCCAD !important;
//       }
//     `;

//     shadow.appendChild(style);
//   }

//   /**
//    * Open Shopify Inbox
//    */
//   function openChat(host) {
//     const button = host.shadowRoot.querySelector(SELECTORS.button);

//     if (!button) {
//       console.warn('[Inbox Chat] Toggle button not found.');
//       return;
//     }

//     button.click();
//   }

//   // Inject styles once widget is available
//   waitForInbox(injectStyles);

//   // Open chat from any .open-chat element
//   document.addEventListener('click', function (e) {
//     const trigger = e.target.closest('.open-chat');
//     if (!trigger) return;

//     e.preventDefault();

//     waitForInbox(openChat);
//   });
// })();

  /* --------------------------------------------
   * Add body classes based on announcement bars
   * -------------------------------------------- */
  if (document.querySelectorAll('.findBarforannouncment').length > 0) {
    document.body.classList.add('no-top-bar-header');
  }

  if (document.querySelectorAll('.sticky-announcement-bar').length > 0) {
    document.body.classList.add('sticky-announcement-bar');
  }

  /* --------------------------------------------
   * FAQ Accordion Toggle Functionality
   * Ensures only one accordion opens at a time
   * -------------------------------------------- */
  const headers = document.querySelectorAll('.faq-drawer-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {

      // Close all other accordions except clicked one
      document.querySelectorAll('.faq-drawer-accordion-header.active').forEach(activeHeader => {
        if (activeHeader !== header) {
          activeHeader.classList.remove('active');
          activeHeader.nextElementSibling.classList.remove('active');
        }
      });

      // Toggle clicked accordion
      header.classList.toggle('active');
      const content = header.nextElementSibling;

      if (header.classList.contains('active')) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  });
});

const formatPriceInUSD = (price) => {
  const formattedPrice = parseFloat(price / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: price % 100 === 0 ? 0 : 2, // Set decimal places based on original price
    maximumFractionDigits: 2 // Maximum fraction digits (cents)
  })
  return formattedPrice
}